export interface NewsItem {
  id: string;
  title: string;
  category: 'company' | 'sponsor' | 'industry';
  categoryName: string;
  date: string;
  summary: string;
  content: string;
  image: string;
  author: string;
}

export const newsCategories = [
  { id: 'all', name: '全部新闻' },
  { id: 'company', name: '企业动态' },
  { id: 'sponsor', name: '赛事赞助' }
];

const newsImages = [
  '/images/news/news2021.png?v=1',
  '/images/news/news2023.png?v=1',
  '/images/news/news2024.png?v=1',
  '/images/news/news2026.png?v=1',
  '/images/news/news2026-1.jpg?v=1'
 ];

export const newsData: NewsItem[] = [
  {
    id: 'news-001',
    title: '第三届临湘市"民间艺人杯"钓友垂钓比赛成功举办',
    category: 'sponsor',
    categoryName: '赛事赞助',
    date: '2021-05-20',
    summary: '2021年5月成功举办第三届临湘市"民间艺人杯"钓友垂钓比赛，吸引各地垂钓爱好者齐聚参赛，为钓友搭建优质展示与竞技平台。',
    content: '2021年5月，民间艺人成功举办第三届临湘市"民间艺人杯"钓友垂钓比赛，吸引各地垂钓爱好者齐聚参赛。\n\n比赛现场气氛热烈，参赛选手们现场切磋技巧、交流经验，展现了高超的垂钓技艺。本次赛事为钓友们搭建了优质的展示与竞技平台，促进了钓鱼文化的传播与交流。\n\n作为本土渔具品牌，民间艺人始终致力于推动钓鱼运动的发展，通过举办各类赛事活动，为广大钓友提供更多交流互动的机会。',
    image: newsImages[0],
    author: '民间艺人'
  },
  {
    id: 'news-002',
    title: '民间艺人赴越南参加渔具展会',
    category: 'company',
    categoryName: '企业动态',
    date: '2023-08-15',
    summary: '2023年赴越南参加渔具展会，展出产品凭借独特设计与优良品质，快速获得东南亚跨境电商经销商关注，有效推动产品进入东南亚市场。',
    content: '2023年，民间艺人赴越南参加国际渔具展会，展出的产品凭借独特设计与优良品质，快速获得东南亚跨境电商经销商的关注。\n\n展会期间，民间艺人浮漂产品以其精湛的工艺和出色的性能，吸引了众多国际买家的目光。通过与当地经销商的深入交流，成功建立了合作关系，有效推动产品进入东南亚市场，为区域业务拓展打下了坚实基础。\n\n此次越南展会是民间艺人国际化战略的重要一步，标志着品牌正式进军东南亚市场。',
    image: newsImages[1],
    author: '民间艺人'
  },
  {
    id: 'news-003',
    title: '民间艺人参与非洲肯尼亚国际渔具产业展览',
    category: 'company',
    categoryName: '企业动态',
    date: '2024-06-10',
    summary: '2024年参与非洲肯尼亚国际渔具产业展览，展示多款自主研发新型渔具，与多国非洲经销商深入洽谈，达成多项合作意向。',
    content: '2024年，民间艺人参与非洲肯尼亚国际渔具产业展览，展示多款自主研发的新型渔具产品，吸引全球采购商与行业人士的广泛关注。\n\n展会期间，民间艺人与多国非洲经销商进行深入洽谈，达成多项合作意向。同时，通过与国际同行的交流，同步掌握了国际渔具行业前沿技术与发展趋势，显著提升了品牌在非洲市场的知名度与影响力。\n\n此次参展是民间艺人拓展非洲市场的重要举措，为品牌国际化发展开辟了新的篇章。',
    image: newsImages[2],
    author: '民间艺人'
  },
  {
    id: 'news-005',
    title: '连续两年参与天津碧海展会',
    category: 'company',
    categoryName: '企业动态',
    date: '2026-03-15',
    summary: '2025年3月、2026年3月连续两年参与天津碧海展会，基于全域营销战略布局，全方位拓展市场影响力、提升品牌知名度。',
    content: '2025年3月、2026年3月，民间艺人连续两年参与天津碧海展会，基于全域营销战略布局，全方位拓展市场影响力、提升品牌知名度。\n\n天津碧海展会是中国北方最具影响力的渔具行业盛会之一。民间艺人通过连续参展，加强了与行业同仁的联动交流，展示了最新的产品研发成果，获得了市场的高度认可。\n\n通过展会平台，民间艺人不仅扩大了品牌知名度，还建立了广泛的行业合作网络，为业务的长期增长筑牢了优势基础。',
    image: newsImages[3],
    author: '民间艺人'
  },
  {
    id: 'news-006',
    title: '与长沙民族学院达成浮标设计深度合作',
    category: 'company',
    categoryName: '企业动态',
    date: '2026-03-20',
    summary: '2026年3月与长沙民族学院达成浮标设计深度合作协议，整合校企资源与技术优势，共同推进浮标设计创新研发。',
    content: '2026年3月，民间艺人与长沙民族学院达成浮标设计深度合作协议，整合校企资源与技术优势，共同推进浮标设计创新研发。\n\n此次合作将充分发挥民间艺人在渔具制造领域的丰富经验和长沙民族学院在设计创新方面的学术优势，通过产学研结合的方式，推动浮标设计的技术升级与创新发展。\n\n双方将在新材料应用、流体力学研究、人体工学设计等领域展开深入合作，致力于开发更具竞争力的高端浮漂产品，助力行业技术升级与高质量发展。',
    image: newsImages[4],
    author: '民间艺人'
  }
];
